var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search_nodata"},[(_vm.showemptyData)?_c('div',{staticClass:"img_wrap"},[_c('img',{attrs:{"src":require("../../assets/images/parent-course/search-nodata.png"),"alt":""}}),_c('p',{staticClass:"desc_text"},[_vm._v(_vm._s(_vm.tipText))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }